import classNames from 'classnames'
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { createAnswer, getMessages } from '../../actions'
import moment from 'moment'
import { profileSelector } from '../../../../modules/profile'
import { connect } from 'react-redux'
import { cloneDeep, orderBy } from 'lodash'

export class MessagesList extends Component {
  static propTypes = {}
  static contextTypes = {formatMessage: PropTypes.any}

  constructor(props) {
    super(props)
  
    this.state = {
      question: {},
      answer: '',
      error: '',
    }
  }

  async componentWillReceiveProps(nextProps){
    if(this.props.selectedDialog != nextProps.selectedDialog && nextProps.selectedDialog){
      this.setState({loaded: false});
      const question = await getMessages(nextProps.selectedDialog);
      this.setState({question, loaded: true})
    }
  }

  handleChange = (e) => {
    this.setState({answer: e.target.value})
  }
  
  handleSend = async () => {
    const {answer, question} = this.state;
    if(answer){
      const data = await createAnswer({answer, parent_id: question.id, name: question.name});
      const tmp = cloneDeep(question)
      tmp.messages = [...tmp.messages, data]
      this.setState({
        question: tmp,
        loaded: true,
        answer: ''
      })
    }
  }

  render() {
    const {formatMessage} = this.context;
    const {selectedDialog, profile} = this.props;
    const { answer, error, question } = this.state;

    const id = question.id;
    const title = question.name;


    const isMyQuestion = profile.id == question.created_by;
    
    const messages = [question, ...(question.messages || [])];
    console.log("🚀 ~ file: MessagesList.jsx ~ line 63 ~ MessagesList ~ render ~ messages", messages)
    return (
      <div className={classNames({
        "messages-list" : 1,
        "messages-list--flex" : 1,
        "h100" : 1,
        "messages-list--width" : 1,
        // "messages-list--toggled" : 1, // TODO add state when input is focused
    })}>

        {!Boolean(question.id) && <ul className={classNames([
            "messages-list__list",
            "messages-list__list--scroll",
            "messages-list__list--indent-left",
        ])}>
            <li className={classNames([
                "messages-list__meta-item",
                "messages-list__meta-item--indent-top",
                "text-center",
            ])}>{formatMessage("Choose request")}</li>
        </ul>}
        {Boolean(question.id) && <ul className={classNames([
                "messages-list__list",
                "messages-list__list--scroll",
                "messages-list__list--indent-left",
            ])}>
                <li className={classNames([
                    "messages-list__meta-item",
                    "messages-list__meta-item--indent-top",
                    "text-center",
                ])}>{formatMessage("A new query was created ID:")}{id}</li>
                <li className={classNames([
                    "messages-list__meta-item",
                    "messages-list__meta-item--amplified",
                    "text-center"
                ])}>{formatMessage("Request name")}: {title}</li>


            {orderBy(messages, ['created_at'], ['asc']).map(_i => 
              <li className={classNames({
                "messages-list__item messages-list__item--send" : profile.id == _i.created_by,
                "messages-list__item messages-list__item--receive" : profile.id != _i.created_by,
                "word-wrap-break" : 1,
              })}>
                <p className="pre-wrap">{_i.question || _i.answer}</p>
                <span className="messages-list__item-time">{moment(_i.created_at * 1000).format('MM-DD-yyyy')}</span>
              </li>
            )}
            
            {/* <li className={classNames({
              "messages-list__item messages-list__item--send" : false,
              "messages-list__item messages-list__item--receive" : true,
              "word-wrap-break" : 1,
            })}>
              <p className="pre-wrap">ddd</p>
              <span className="messages-list__item-time">1</span>
            </li>  */}
        </ul>}
        {Boolean(question.id) && <div className="messages-list__input messages-list__input--x-offset">
            <textarea
                onChange={this.handleChange}
                autoFocus
                placeholder = {formatMessage("Write a message")}
                value={answer}
                // onKeyDown={this.handleKeyDown}
            ></textarea>
            {/*<span className="messages-list__input-attach"></span>*/}
            <span onClick={this.handleSend} className="messages-list__input-send pointer"></span>
            {
                error &&
                <span className="messages-list__input-error">{error}</span>
            }
        </div>}
    </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  profile: profileSelector(state),
})

const mapDispatchToProps = {
}

export default connect(mapStateToProps, mapDispatchToProps)(MessagesList)



// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/Support/components/MessagesList/MessagesList.jsx